import React, { useContext, useState } from "react";
import { Input, DropList } from "../../UIcomponent/Form";
import Col from "../../UIcomponent/Column";
import StyledButton from "../../UIcomponent/Button";
import { ThemeContext } from "styled-components";
import Text from "../../UIcomponent/Text";
import CountryData from "../../Utility/CountryData";
import "./TeacherRegisterForm.scss";
import OtpInput from "react-otp-input";
import Question from "../../UIcomponent/Icon/Question";
import sortDown from "../../Assets/icon/sortDown.svg";
// import Image from '../../UIcomponent/Image'
import { TimezoneList } from "../../Utility/TimezoneList";
import { PersianDigitReplacer } from "../../Utility/Method/PersianDigitReplacer";
import { Statistic } from "antd";
import { Loader } from "../../UIcomponent/Loader";
import LocalAppConfig from "../../Utility/Method/LocalAppConfig";
import LocalConfig from "../../Utility/Method/LocalConfig";
import LocalContext from "../../Context/LocalContetxt";
const TeacherRegisterForm = (props) => {
  const timezoneData = TimezoneList;
  const { Countdown } = Statistic;
  const [showList, setShowList] = useState(false);
  const [showTZlist, setShowTZlist] = useState(false);
  const [showLanguage, setShowLanguage] = useState(false);
  const [countries, setCountries] = useState(CountryData);
  const [TimeZoneList, setTimeZoneList] = useState(timezoneData);
  const {
    flowType,
    formik,
    formErrosStyle,
    State,
    setState,
    info,
    setInfo,
    lang,
    RegisterFormEdit,
    ResendCode,
  } = props;
  const theme = useContext(ThemeContext);
  const appConfig = LocalAppConfig.Get();
  const onChangeFilter = (value, data, setState, filterKey1, filterKey2) => {
    let filterState = data.filter(
      (each) =>
        (`${"+" + each[`${filterKey1}`]}`
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          `${each[`${filterKey2}`]}`
            .toLowerCase()
            .includes(value.toLowerCase())) &&
        each
    );
    if (value.length !== 0) {
      setState(filterState);
    } else {
      setState(data);
    }
  };
  const languages = appConfig.Language || {};
  return (
    <>
      {State.hasVerifyCode === false && (
        <>
          <Col
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            style={{
              justifyContent: "space-between",
            }}
          >
            <Col
              xl={16}
              lg={16}
              md={16}
              sm={16}
              xs={16}
              style={{
                flexDirection: "column",
              }}
            >
              <Input
                letterSpace="2px"
                name="mobile"
                lable="mobile"
                validateonchange={true}
                lang={lang}
                type="tel"
                tabIndex={2}
                placeholder="شماره موبایل"
                autocomplete={"username"}
              />
            </Col>
            <Col
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={6}
              style={{
                justifyContent: "flex-end",
              }}
            >
              <DropList
                lang={"en"}
                show={showList}
                clicked={showList}
                letterSpace="3px"
                justifyContent="center"
                autocomplete={false}
                removeReadOnly={true}
                type="tel"
                width="45px"
                value={formik.values.phoneCode}
                disabled={State.hasVerifyCode}
                id="phoneCode"
                name="phoneCode"
                tabIndex={1}
                onChange={(e) => {
                  formik.setFieldValue(
                    "phoneCode",
                    PersianDigitReplacer(e.target.value)
                  );
                  onChangeFilter(
                    e.target.value,
                    CountryData,
                    setCountries,
                    "phoneCode"
                  );
                }}
                icon={sortDown}
                contentStyle={{
                  width: "400%",
                  left: "0px",
                  top: "65px",
                }}
                onClick={() => setShowList(true)}
                onClose={() => setShowList(false)}
              >
                {showList &&
                  countries.length > 0 &&
                  countries.map((each, index) => {
                    return (
                      <Col
                        xl={24}
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{
                          justifyContent: "space-evenly",
                          height: "35px",
                          minHeight: "35px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          formik.setFieldValue(
                            "phoneCode",
                            `+${each.phoneCode}`
                          );
                          setTimeout(() => setShowList(false), 0);
                          setTimeout(() => {
                            setInfo({
                              ...info,
                              phoneCode: `+${each.phoneCode}`,
                            });
                          }, 1);
                        }}
                      >
                        <Col
                          xl={8}
                          lg={8}
                          md={8}
                          sm={8}
                          xs={8}
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "10px",
                            backgroundColor: "none",
                            backgroundImage: `url(https://www.countryflags.io/${each.code.toLowerCase()}/shiny/64.png)`,
                          }}
                        ></Col>
                        <Col
                          xl={8}
                          lg={8}
                          md={8}
                          sm={8}
                          xs={8}
                          style={{
                            opacity: "0.7",
                            height: "100%",
                            fontSize: theme.fontSizeSm,
                            justifyContent: "flex-end",
                          }}
                        >
                          {each.value}
                        </Col>
                        <Col
                          xl={4}
                          lg={8}
                          md={8}
                          sm={8}
                          xs={8}
                          style={{
                            opacity: "0.7",
                            fontSize: theme.fontSizeMd,
                            fontWeight: 800,
                            justifyContent: "flex-end",
                          }}
                        >
                          {each.phoneCode}+
                        </Col>
                      </Col>
                    );
                  })}
                {showList && countries.length === 0 && (
                  <Col>موردی یافت نشد</Col>
                )}
              </DropList>
            </Col>
          </Col>
          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={formErrosStyle("flex-start")}
            >
              {flowType === "mobile" &&
              formik.touched.mobile &&
              formik.errors.mobile
                ? formik.errors.mobile
                : flowType === "email" &&
                  formik.touched.email &&
                  formik.errors.email
                ? formik.errors.email
                : ""}
            </Col>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={formErrosStyle("flex-end")}
            >
              {formik.errors.phoneCode}
            </Col>
          </Col>
          <Col
            style={{
              justifyContent: "space-between",
            }}
          >
            <Col
              xl={11}
              lg={11}
              md={11}
              sm={11}
              xs={11}
              style={{
                flexDirection: "column",
              }}
            >
              <Input
                disabled={State.hasVerifyCode}
                name="firstName"
                lable="firstName"
                autocomplete={"name"}
                lang={lang}
                tabIndex={3}
                placeholder="نام"
              />
              <Text style={formErrosStyle(formik.touched.firstName)}>
                {formik.touched.firstName && formik.errors.firstName}
              </Text>
            </Col>
            <Col
              xl={11}
              lg={11}
              md={11}
              sm={11}
              xs={11}
              style={{
                flexDirection: "column",
              }}
            >
              <Input
                disabled={State.hasVerifyCode}
                name="lastName"
                lable="lastName"
                autocomplete="family-name"
                lang={lang}
                tabIndex={4}
                placeholder="نام خانوادگی"
              />
              <Text style={formErrosStyle(formik.touched.lastName)}>
                {formik.touched.lastName && formik.errors.lastName}
              </Text>
            </Col>
          </Col>
          {/* } */}
          <Input
            disabled={State.hasVerifyCode}
            id="pass"
            name="pass"
            type="password"
            autocomplete={"current-password"}
            lang={lang}
            tabIndex={5}
            placeholder="رمز عبور"
          />
          <Text style={formErrosStyle(formik.touched.pass)}>
            {formik.touched.pass && formik.errors.pass}
          </Text>
          <Col xl={20} lg={20} md={20} sm={20} xs={20}>
            <DropList
              lang={"en"}
              show={showLanguage}
              notTypable={true}
              clicked={showLanguage}
              lable="وقت محلی"
              disabled={State.hasVerifyCode}
              id="language"
              name="language"
              onChange={(e) => {
                formik.setFieldValue(
                  "language",
                  PersianDigitReplacer(e.target.value)
                );
              }}
              tabIndex={6}
              icon={sortDown}
              contentStyle={{
                width: "100%",
                right: "0px",
                top: window.innerWidth > 768 && "65px",
                bottom: window.innerWidth < 768 && "65px",
              }}
              onClick={() => setShowLanguage(true)}
              onClose={() => setShowLanguage(false)}
              autocomplete={false}
              removeReadOnly={true}
            >
              {Object.keys(languages).map((code) => {
                return (
                  <Col
                    xl={24}
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{
                      justifyContent: "space-evenly",
                      height: "45px",
                      cursor: "pointer",
                      minHeight: "45px",
                    }}
                    onClick={() => {
                      formik.setFieldValue("language", languages[code]);
                      setTimeout(() => setShowLanguage(false), 0);
                    }}
                  >
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{
                        justifyContent: "center",
                        fontSize: theme.fontSizeMd,
                        fontWeight: "600",
                        fontFamily: "Arial",
                      }}
                    >
                      {languages[code]}
                    </Col>
                  </Col>
                );
              })}
            </DropList>
          </Col>
          <Col
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            style={{
              justifyContent: "space-between",
              flexDirection: "row-reverse",
            }}
          >
            <Col xl={20} lg={20} md={20} sm={20} xs={20}>
              <DropList
                lang={"en"}
                show={showTZlist}
                clicked={showTZlist}
                lable="وقت محلی"
                disabled={State.hasVerifyCode}
                id="timezone"
                name="timezone"
                onChange={(e) => {
                  formik.setFieldValue(
                    "timezone",
                    PersianDigitReplacer(e.target.value)
                  );
                  onChangeFilter(
                    e.target.value,
                    timezoneData,
                    setTimeZoneList,
                    "timezone",
                    "name"
                  );
                }}
                tabIndex={6}
                icon={sortDown}
                contentStyle={{
                  width: "100%",
                  right: "0px",
                  top: window.innerWidth > 768 && "65px",
                  bottom: window.innerWidth < 768 && "65px",
                }}
                onClick={() => setShowTZlist(true)}
                onClose={() => setShowTZlist(false)}
                autocomplete={false}
                removeReadOnly={true}
              >
                {showTZlist === true &&
                  TimeZoneList.length > 0 &&
                  TimeZoneList.map((tz) => {
                    return (
                      <Col
                        xl={24}
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{
                          justifyContent: "space-evenly",
                          height: "45px",
                          cursor: "pointer",
                          minHeight: "45px",
                        }}
                        onClick={() => {
                          formik.setFieldValue("timezone", tz.name);
                          setTimeout(() => setShowTZlist(false), 0);
                        }}
                      >
                        <Col
                          xl={6}
                          lg={6}
                          md={6}
                          sm={8}
                          xs={8}
                          style={{
                            justifyContent: "center",
                            fontSize: theme.fontSizeMd,
                            fontWeight: "600",
                            fontFamily: "Arial",
                          }}
                        >
                          {tz.timezone.includes("-")
                            ? tz.timezone.split("-").join("") + " - "
                            : tz.timezone.split("+").join("") + " + "}
                        </Col>
                        <Col
                          xl={14}
                          lg={14}
                          md={14}
                          sm={12}
                          xs={12}
                          style={{
                            justifyContent: "flex-end",
                            fontSize: theme.fontSizeSm,
                            direction: "rtl",
                          }}
                        >
                          {tz.name}
                        </Col>
                      </Col>
                    );
                  })}
                {showTZlist === true && TimeZoneList.length === 0 && (
                  <Col>موردی یافت نشد</Col>
                )}
              </DropList>
            </Col>
            <Col
              style={{
                alignItems: "flex-end",
                height: "45px",
                justifyContent: "flex-end",
                width: "auto",
              }}
              className="c__Register__Info"
            >
              {/* <Image
                                className='o__Register__questionIcon'
                                style={{
                                    cursor: 'pointer'
                                }}
                                src={questionIcon} width='25px' height='25px' /> */}
              <Question />

              <Col className="o__Register__InfoContainer">
                به منظور تنظیم ساعت محلی شما با زبان آموز این گزینه را متناسب
                انتخاب کنید تا در زمان‌بندی کلاس ها مشکلی به وجود نیاید.
              </Col>
            </Col>
          </Col>
        </>
      )}
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        style={{
          marginTop: "15px",
          flexDirection: "column",
        }}
      >
        {formik.isSubmitting === true && State.hasVerifyCode === true ? (
          <>
            <Loader height={120} />
            <Col
              style={{
                height: "60px",
              }}
            >
              چند لحظه منتظر بمانید ...
            </Col>
          </>
        ) : (
          <>
            {State.hasVerifyCode === true && (
              <>
                <Col
                  style={{
                    justifyContent: "flex-start",
                    minHeight: "25px",
                    flexWrap: "wrap",
                    color: theme.text,
                    fontSize: theme.fontSizeMd,
                  }}
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                >
                  کد ارسال شده به{" "}
                  <span
                    style={{
                      color: theme.textBold,
                      direction: "ltr",
                      fontWeight: "800",
                      height: "100%",
                      fontSize: theme.fontSizeLg,
                      fontFamily: "Fa_IRANSans",
                      padding: "5px",
                      margin: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    {info.phoneCode === "+98" &&
                    `${formik.values.mobile[0]}` === "0"
                      ? formik.values.mobile
                      : info.phoneCode + formik.values.mobile}
                  </span>{" "}
                  را وارد نمایید
                </Col>
                <OtpInput
                  value={formik.values.code}
                  name="code"
                  id="code"
                  containerStyle={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "50px",
                    direction: "ltr",
                  }}
                  inputStyle={{
                    display: "flex",
                    border: "none",
                    width: "35px",
                    color: theme.text,
                    fontSize: theme.fontSizeLg,
                    borderRadius: "none",
                    fontWeight: "800",
                    fontFamily: "Fa_IRANSans",
                    borderBottom: `2px solid ${
                      State.shake === false ? theme.secondary : theme.danger
                    }`,
                  }}
                  focusStyle={{
                    border: "none",
                    outline: "none",
                  }}
                  disabledStyle={{
                    border: "none",
                    borderBottom: "none",
                    borderRadius: "none",
                    outline: "none",
                    opacity: "0.5",
                    backgroundColor: "transparent",
                  }}
                  shouldAutoFocus={true}
                  isDisabled={formik.isSubmitting === true ? true : false}
                  onChange={(otp) => {
                    setState({
                      ...State,
                      shake: false,
                    });
                    formik.setFieldValue("code", PersianDigitReplacer(otp));
                    // InfoCtxt.setInfo({ ...InfoCtxt.info, Code: otp })
                    // if (otp.length === 6) {
                    //     setTimeout(() => formik.handleSubmit(), 1500)
                    // }
                  }}
                  numInputs={6}
                />
              </>
            )}
            {State.mode === "register" && State.hasVerifyCode === true ? (
              <Col
                style={{
                  margin:
                    State.mode === "register" && State.hasVerifyCode === true
                      ? "15px 0px 15px 0px"
                      : "0px 0px 0px 0px",
                }}
                xl={24}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className="c__ModeHandler"
              >
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Col
                    style={{
                      justifyContent: "flex-start",
                      color: theme.primary,
                      fontSize: theme.fontSizeMd,
                    }}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={22}
                    xs={22}
                    onClick={() => RegisterFormEdit()}
                  >
                    ویرایش اطلاعات
                  </Col>
                  <Col
                    style={{
                      justifyContent: "flex-end",
                    }}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={22}
                    xs={22}
                  >
                    {State.hasVerifyCode === true && State.expireTime !== null && (
                      <Countdown
                        valueStyle={{
                          color: theme.primary,
                          fontWeight: 800,
                          fontSize: theme.fontSizeXl,
                          fontFamily: "inherit",
                          letterSpacing: "2px",
                        }}
                        value={State.expireTime}
                        format="mm:ss"
                        onFinish={() =>
                          setState({
                            ...State,
                            expireTime: null,
                          })
                        }
                      />
                    )}
                    {State.hasVerifyCode === true && State.expireTime === null && (
                      <Col
                        onClick={() => ResendCode(formik, formik.values)}
                        style={{
                          backgroundColor: theme.primary,
                          color: theme.white,
                          fontWeight: 800,
                          fontSize: theme.fontSizeMd,
                          padding: "5px 8px 5px 8px",
                          borderRadius: theme.borderRadius,
                        }}
                      >
                        دریافت مجدد کد
                      </Col>
                    )}
                  </Col>
                </Col>
              </Col>
            ) : null}

            <StyledButton
              style={{
                marginTop: "5px",
                fontWeight: 800,
                fontSize: theme.fontSizelg,
                backgroundColor: theme.secondary,
                color: theme.white,
              }}
              tabIndex={7}
              width={"100%"}
              height="45px"
              loading={formik.isSubmitting}
              disable={formik.isValid === false}
              type="submit"
            >
              ادامه
            </StyledButton>
          </>
        )}
      </Col>
    </>
  );
};

export default TeacherRegisterForm;
